import React from "react";

export default function Section4() {
    return (
        <div className="w-full Section3 px-5 md:px-0 pt-[2%]">
            <div className="flex flex-col items-center w-full md:flex-row justify-evenly section3-container">
                <div className="w-full md:w-[36%] text-[#373737]">
                    <h2 className="text-[26px] md:text-[34px] font-bold leading-[32px] md:leading-[41px] text-[#DA2128] my-[0.67em] pb-[2%]">
                        Shopify Plus Development Store for Your Business
                    </h2>
                    <p className="leading-[20px] pb-[1%] text-base mb-5">
                        Our team specializes in building efficient, scalable Shopify Plus development stores that are easy to navigate and optimized for growth. We ensure your website is ready to handle the demands of a growing business while providing an excellent user experience.
                    </p>
                    <h2 className="text-[26px] md:text-[34px] font-bold leading-[32px] md:leading-[41px] text-[#DA2128] my-[0.67em] pb-[2%]">
                        Why Choose Mean3 for Shopify Plus?
                    </h2>
                    <p className="leading-[20px] pb-[1%] text-base mb-5">
                        As a top Shopify Plus development company, we understand what it takes to succeed in the e-commerce world. Our Shopify Plus services are designed to help you create a high-performing online store that supports your business goals and boosts sales. Partner with us to build the perfect Shopify Plus website and take your business to the next level.
                    </p>
                </div>

                <div className="w-full md:w-auto">
                    <img
                        src="../../../assets/computer-shopify.png"
                        alt="Computer Logo"
                        className="w-full md:w-auto cover"
                    />
                </div>
            </div>
            <div className="line my-[55px] md:my-[4%] mx-auto w-[70%] md:w-[61%] shadow-line h-2 rounded-[100%]"></div>
        </div>
    );
}
